<template>
  <div class="container">
    <div class="main-box">
      <img src="~@/assets/guide3.jpg" alt="指南" />
    </div>

    <div class="shop-box">
      <div class="shop-box-btns">
        <van-button
          block
          round
          @click="toExchange"
          color="linear-gradient(to right, #0173FF, #5FD2FF)"
        >
          先兑换
        </van-button>
        <van-button
          class="open-miniapp-btn"
          block
          round
          color="linear-gradient(to top, #FE0335, #FF7366)"
        >
          <div class="launch-btn"></div>
          再消费
        </van-button>
      </div>

      <div class="shop-box-tips">
        <span class="blue">先兑换：</span>会员积分兑换成大品牌商家积分。
      </div>
      <div class="shop-box-tips">
        <span class="red">再消费：</span>跳转到大品牌商家联盟小程序。
      </div>

      <template v-if="settings.sbcIcon.length">
        <div class="shop-box-head">
          <div class="shop-box-head-title">支持超级商家品牌</div>
        </div>
        <div class="shop-box-icons">
          <van-image
            class="shop-box-icon"
            fit="cover"
            :src="item"
            round
            v-for="item in settings.sbcIcon"
            :key="item"
          />
          <!-- <div class="shop-box-noicon" v-else>暂无超级商家品牌</div> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import api from "../../api";
export default {
  title: "超商联盟指南",
  data() {
    return {
      settings: {
        sbcIcon: [],
      },
    };
  },
  created() {
    this.getSettings();
  },
  mounted() {},
  methods: {
    is_weixn() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    is_version() {
      const wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
      // 微信正常版本号 wxInfo[1] = "8.0.1840" (示例)
      // 微信异常版本号 wxInfo[1] = "8.0.1.1840" (示例)
      //进行split转成数组进行判断 ['8','0','1','1840'] (示例)
      const version = wxInfo[1].split(".");
      // console.log('version', version);
      // 判断版本在7.0.12及以上的版本
      if (Number(version[0]) > 7) {
        return true;
      } else if (Number(version[0]) === 7) {
        if (Number(version[1]) > 0) {
          return true;
        } else if (Number(version[1]) === 0) {
          if (Number(version[2]) >= 12) return true;
        }
      }
      return false;
    },
    /* 
    {
        ele:"", // 元素ID
        appid:"", // 小程序id号 wx_****
        username: "", // gh_**** 
        url:"", // 跳转小程序的页面路径地址 例: pages/home/home.html - (后面必须带上.html后缀 否则IOS跳转时出现小程序页面未配置)
        content:"" // html字符串 例: "<button>点我</button>"
    }
  */
    wx_launch(info) {
      if (!this.is_weixn()) return;
      if (this.is_version) {
        const btn = info.ele.querySelector(".launch-btn"); //获取元素
        const script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
        script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
        script.text = info.content; // 自定义的html字符串内容
        const html = `<wx-open-launch-weapp
                      style="display: block;width: 100%;height: 100%" 
                      appid="${info.appid}">${script.outerHTML}</wx-open-launch-weapp>`;
        btn.innerHTML = html; // html字符串赋值
      } else {
        alert("您的版本号不支持");
      }
    },
    getSettings() {
      api.superBusinessCard.sbcChargeSetting((data) => {
        console.log(data, "超商卡设置***");
        this.settings = data;
        const box = this.$el.querySelector(".launch-btn");
        console.log(this.settings, this.settings.miniProgramId);
        this.wx_launch({
          ele: this.$el,
          // appid: "wx2b4c74af074f2085",
          appid: this.settings.miniProgramId,
          content: `<div class="test-btn"></div>
          <style>
            .test-btn{
              width: ${box.clientWidth}px;
              height: ${box.clientHeight}px;
            }
          </style>`,
        });
      });
    },
    toExchange() {
      // 跳转会兑换超商卡
      this.$routerPush(this, "/pages/superBusinessCard/ExchangeCard");
    },
  },
};
</script>
<style lang="less" scoped>
.open-miniapp-btn {
  position: relative;
  .launch-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #fff;
  padding-bottom: calc(49vw + constant(safe-area-inset-bottom));
  padding-bottom: calc(49vw + env(safe-area-inset-bottom));

  .main-box {
    padding: 5vw;
    /* display: flex;
    flex-direction: column;
    align-items: center; */

    img {
      width: 100%;
    }
  }
  .shop-box {
    position: fixed;
    left: 0;
    right: 0;
    bottom: calc(0px + constant(safe-area-inset-bottom));
    bottom: calc(0px + env(safe-area-inset-bottom));
    background-color: #fff;
    border-top: 1px solid #f3f3f3;

    .shop-box-btns {
      display: flex;
      justify-content: center;
      .van-button {
        width: 40vw;
        margin: 3.5vw 3vw;
      }
    }

    .shop-box-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 4.67vw;
      .shop-box-head-title {
        font-weight: 600;
        font-size: 4.27vw;
      }
    }
    .shop-box-tips {
      padding: 0 7.67vw;
      font-weight: 600;
      font-size: 4.27vw;
      padding-bottom: 1.75vw;
      color: #3d3d3d;
      .blue {
        color: #3662ec;
      }
      .red {
        color: #fa5151;
      }
    }

    .shop-box-icons {
      overflow-x: auto;
      padding: 4vw 4.67vw 6.67vw;
      display: flex;
      .shop-box-icon {
        width: 13.33vw;
        height: 13.33vw;
        flex-shrink: 0;
        margin-right: 4vw;
        border: 1px solid #f6f6f6;
        &:last-child {
          margin-right: 0;
        }
      }
      // .shop-box-noicon {
      //   height: 13.33vw;
      //   line-height: 13.33vw;
      //   color: #ff5457;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/superBusinessCard/UsageGuidelines.vue